export default __webpack_public_path__ + "static/media/icons-menu-notes-active.54f61011.svg";